import { RestService } from "../common/rest-service";

export class AddressService extends RestService {
  constructor() {
    super();

    this.getNeighborhoods = this.getNeighborhoods.bind(this);
    this.getNeighborhood = this.getNeighborhood.bind(this);
    this.getStates = this.getStates.bind(this);
    this.getState = this.getState.bind(this);
    this.postZipCode = this.postZipCode.bind(this);
    this.getZipCode = this.getZipCode.bind(this);
  }

  /**
      Função para ter acesso a uma lista de bairros com base no CEP fornecido
  
      @param {string} zip_code - CEP
  
      @returns {promise} Lista de bairros com diversas informações como cidade e Estado
    */
  async getNeighborhoods(zip_code) {
    return await this.get("/address/neighborhoods/", { zip_code: zip_code });
  }

  /**
      Função para ter acesso a informações de um bairro específico
  
      @param {integer} id - ID do bairro
  
      @returns {promise} Informações do bairro
    */
  async getNeighborhood(id) {
    return await this.get(`/address/neighborhoods/${id}/`);
  }

  /**
      Função para ter acesso a uma lista de Estados
  
      @param {boolean} active - Boolean indicando se a lista vai conter somente Estados ativos
  
      @returns {promise} Lista de Estados
    */
  async getStates(active) {
    return await this.get("/address/states/", { active: active });
  }

  /**
      Função para ter acesso a informações de um Estado específico
  
      @param {integer} id - ID do Estado
  
      @returns {promise} Informações do Estado
    */
  async getState(id) {
    return await this.get(`/address/states/${id}/`);
  }

  /**
      Função para validar um CEP e retornar informações dele caso seja válido
  
      @param {string} zip_code_str - CEP
  
      @returns {promise} Informações do CEP
    */
  async postZipCode(zip_code_str) {
    return await this.post(`/address/zip-codes/${zip_code_str}/`);
  }

  /**
      Função para retornar informações de um CEP validado
  
      @param {string} zip_code_str - CEP
  
      @returns {promise} Informações do CEP
    */
  async getZipCode(zip_code_str) {
    return await this.get(`/address/zip-codes/${zip_code_str}/`);
  }
}
